(function (upp) {
    'use strict';
    
    var PERSON = 1,
        SPAIN = 'ES';

    upp.directive('shippingBillingAddressTpl', [
        function () {
            return {
                scope: {
                    address: '=',
                    required: '=',
                    countries: '=',
                    hide: '=',
                    addressType: '@',
                    personType: '=',
                    dni: '=',
                    phone: '='
                },
                replace: true,
                restrict: 'E',
                templateUrl: require('../templates/cart-shipping_billing_address.html'),
                controller: ['$scope', function ($scope) {

                    var unwatch = $scope.$watch('address', function(address) {
                        if (address && address.country === null) {
                            address.country = 'ES';
                            unwatch();
                        }
                    });

                    var updateFields = function () {
                        var isPerson = $scope.personType == PERSON;
                        if ($scope.address && $scope.address.country === SPAIN) {
                            $scope.address.country = 'ES';
                            $scope.documentType = isPerson ? 'DNI' : 'CIF';
                            $scope.requiredDni = true;
                        } else {
                            $scope.documentType = 'VAT';
                            $scope.requiredDni = !isPerson;
                        }
                    };
                    updateFields();
                    $scope.$watch('personType', updateFields);
                    $scope.$watch('address.country', updateFields);
                    $scope.onCountryChange = updateFields;
                }]
            }
        }]);

})(upp);




// WEBPACK FOOTER //
// ./src/app/modules/cart/directives/cart-shipping_billing_address-directive.js